// The four Āmnāya Pīṭhas established by Sri Adi Shankaracharya, with the
// traditional Maṭhāmnāya assignments (Veda, Mahāvākya, first disciple, Devi).
// Current Acharya + images are admin-editable overrides stored in
// site_settings.amnaya_peethas (keyed by slug).

const IMG = "https://static.prod-images.emergentagent.com/jobs/f79bd64e-30d1-4119-8097-970fcb1907b0/images/";

export const SHANKARA_IMG = IMG + "2c657b7dadcd5d54ba897da67448afc81fd706c817964756e297bf4868f60b4e.jpeg";

export const AMNAYA_PEETHAS = [
  {
    slug: "sringeri",
    direction: "Dakṣiṇāmnāya",
    direction_en: "Southern",
    name: "Sringeri Sharada Peetham",
    deva_name: "श्रृंगेरी शारदा पीठम्",
    veda: "Yajur Veda",
    veda_deva: "यजुर्वेद",
    mahavakya: "Aham Brahmāsmi",
    mahavakya_deva: "अहं ब्रह्मास्मि",
    mahavakya_meaning: "I am Brahman",
    first_acharya: "Sri Sureshvaracharya",
    devi: "Goddess Sharada (Saraswati)",
    deity: "Sri Chandramaulishwara & Sharadamba",
    sampradaya: "Bhūrivala",
    tirtha_names: "Sarasvatī, Bhāratī, Purī",
    location: "Sringeri, Karnataka",
    river: "Tungabhadra",
    current_acharya: "Jagadguru Sri Sri Vidhushekhara Bharati Mahaswamiji (36th)",
    predecessor: "Jagadguru Sri Sri Bharati Tirtha Mahaswamiji (35th)",
    image: IMG + "aa10d543b28d0a8ad26b93ad67de04930e3216fec5951d9c346db2af0cb18b09.jpeg",
    summary:
      "The Southern Āmnāya, the first maṭha established by Adi Shankara on the banks of the Tungabhadra. Its unbroken lineage of Jagadgurus has guided Sanātana Dharma for over twelve centuries, with Goddess Sharada as the presiding deity of wisdom.",
    website: "https://www.sringeri.net/",
  },
  {
    slug: "dwaraka",
    direction: "Paścimāmnāya",
    direction_en: "Western",
    name: "Dwaraka Sharada Peetham (Kalika Matha)",
    deva_name: "द्वारका शारदा पीठम्",
    veda: "Sama Veda",
    veda_deva: "सामवेद",
    mahavakya: "Tattvamasi",
    mahavakya_deva: "तत्त्वमसि",
    mahavakya_meaning: "That thou art",
    first_acharya: "Sri Padmapadacharya",
    devi: "Goddess Bhadrakali (Siddheshwari)",
    deity: "Sri Siddheshwara & Bhadrakali, Sharada",
    sampradaya: "Kīṭavala",
    tirtha_names: "Tīrtha, Āśrama",
    location: "Dwaraka, Gujarat",
    river: "Gomati (coast of the Arabian Sea)",
    current_acharya: "Jagadguru Shankaracharya Sri Sadananda Saraswati",
    predecessor: "Jagadguru Swami Swaroopanand Saraswati",
    image: IMG + "350676858ab52f0def71fd9398d46a47946dc94ed0b525c79df4407cca9fbdf2.jpeg",
    summary:
      "The Western Āmnāya at Dwaraka, the sacred city of Sri Krishna. Entrusted with the Sama Veda, it upholds the great utterance Tattvamasi — the oneness of the individual self with the Supreme.",
    website: "",
  },
  {
    slug: "puri",
    direction: "Pūrvāmnāya",
    direction_en: "Eastern",
    name: "Govardhana Peetham, Puri",
    deva_name: "गोवर्धन पीठम्, पुरी",
    veda: "Rig Veda",
    veda_deva: "ऋग्वेद",
    mahavakya: "Prajñānam Brahma",
    mahavakya_deva: "प्रज्ञानं ब्रह्म",
    mahavakya_meaning: "Consciousness is Brahman",
    first_acharya: "Sri Hastamalakacharya",
    devi: "Goddess Vimala",
    deity: "Sri Jagannath & Vimala",
    sampradaya: "Bhogavala",
    tirtha_names: "Vana, Araṇya",
    location: "Puri, Odisha",
    river: "Mahanadi (coast of the Bay of Bengal)",
    current_acharya: "Jagadguru Shankaracharya Swami Nischalananda Saraswati",
    predecessor: "Jagadguru Swami Niranjan Dev Tirtha",
    image: IMG + "9cc30dae729dcd00b99f36587c733098544f791304abf1852304c2cce786b946.jpeg",
    summary:
      "The Eastern Āmnāya at Puri, abode of Lord Jagannath. Keeper of the Rig Veda, it proclaims Prajñānam Brahma — that pure consciousness itself is the Absolute.",
    website: "https://www.govardhanpeeth.org/",
  },
  {
    slug: "jyotirmath",
    direction: "Uttarāmnāya",
    direction_en: "Northern",
    name: "Jyotirmath Peetham (Badari)",
    deva_name: "ज्योतिर्मठ पीठम् (बद्री)",
    veda: "Atharva Veda",
    veda_deva: "अथर्ववेद",
    mahavakya: "Ayam Ātmā Brahma",
    mahavakya_deva: "अयमात्मा ब्रह्म",
    mahavakya_meaning: "This Self is Brahman",
    first_acharya: "Sri Totakacharya",
    devi: "Goddess Purnagiri",
    deity: "Sri Badrinarayan & Purnagiri",
    sampradaya: "Ānandavala",
    tirtha_names: "Giri, Parvata, Sāgara",
    location: "Jyotirmath (Joshimath), Uttarakhand",
    river: "Alaknanda (Himalayas)",
    current_acharya: "Jagadguru Shankaracharya Swami Avimukteshwaranand Saraswati",
    predecessor: "Jagadguru Swami Swaroopanand Saraswati",
    image: IMG + "d1269365d14296987a78af208dd55a9562f0414d779f9e07ea307af5def37158.jpeg",
    summary:
      "The Northern Āmnāya near Badrinath in the Himalayas. Guardian of the Atharva Veda, it carries the teaching Ayam Ātmā Brahma — the innermost Self is none other than Brahman.",
    website: "",
  },
];

// Merge admin overrides (image, current_acharya, predecessor, summary, website, note)
// from site_settings.amnaya_peethas[slug] onto the base data.
export function peethaWithOverrides(p, settings) {
  const ov = (settings?.amnaya_peethas || {})[p.slug] || {};
  return { ...p, ...Object.fromEntries(Object.entries(ov).filter(([, v]) => v !== "" && v != null)) };
}

export function shankaraOverrides(settings) {
  return (settings?.amnaya_peethas || {})._shankara || {};
}
